import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'card-list',
    templateUrl: './card-list.component.html',
    styleUrls: ['./card-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CardListComponent {}
